import { takeLatest } from "redux-saga";
import { call, select } from "redux-saga/effects";
import fetchWithCSRFToken from "Utils/fetchWithCSRFToken";

import { TOGGLE_FAVORITE_PLAN } from "./Actions";
import { getFavoritePlanIDs } from "./Selectors";

function updateFavoritePlansApi(favoritePlanIDs, companyProfile) {
  const payload = favoritePlanIDs;
  const url = `/small-group/select-plan/update-favorite-plans?company_id_token=${companyProfile.id_token}&favoritePlanIDs=${JSON.stringify(payload)}`;
  return fetchWithCSRFToken(url, { method: "POST", processData: false }).then((response) => response.json());
}

function* updateFavoritePlans() {
  const favoritePlanIDs = yield select(getFavoritePlanIDs);
  const companyProfile = yield select((state) => state.companyProfile);
  yield call(updateFavoritePlansApi, favoritePlanIDs, companyProfile);
}

export function* FavoritePlanSaga(): Generator<any, any, any> {
  yield takeLatest(TOGGLE_FAVORITE_PLAN, updateFavoritePlans);
}
